module.exports = __webpack_public_path__ + "img/sdg_icon_11.90806803.png";